export function parseNeverDef() {
    return {
        not: {},
    };
}
